<script setup>
import { useI18n } from "vue-i18n";
import { getBlock } from "@Utils/project";
import Draggable from "vuedraggable";
import { computed } from "vue";
import _filter from "lodash/filter";
import _map from "lodash/map";
import _findIndex from "lodash/findIndex";
import _cloneDeep from "lodash/cloneDeep";
import { createCloneBlock } from "./utils";
import { useStore } from "@/Stores/textBlocks";
import Disclosure from "./Disclosure.vue";
import SidebarBlock from "./SidebarBlock.vue";

const emit = defineEmits(["addBlock", "start", "end"]);

const { t: __ } = useI18n();
const store = useStore();

const textBlock = getBlock("text");

const filteredBlocks = computed(() => {
    let blocks = _filter(store.otomaticAITextBlocks, (block) => {
        return block.is_text_option;
    });

    return blocks;
});

const formattedBlocks = computed(() => {
    return _map(filteredBlocks.value, (block) => {
        let b = _cloneDeep(textBlock);

        b.name = block.name;
        b.parameters[_findIndex(b.parameters, ["id", "name"])].default = block.name;
        b.parameters[_findIndex(b.parameters, ["id", "use_live_data"])].default = block.use_live_data;
        b.parameters[_findIndex(b.parameters, ["id", "external_links_enabled"])].default = block.external_links_enabled;
        b.parameters[_findIndex(b.parameters, ["id", "internal_links_enabled"])].default = block.internal_links_enabled;
        b.parameters[_findIndex(b.parameters, ["id", "prompt"])].default = block.prompt;

        return b;
    });
});
</script>

<template>
    <Disclosure :title="__('Options IA')">
        <Draggable
            :list="formattedBlocks"
            tag="div"
            :group="{ name: 'blocks', pull: 'clone', put: false }"
            :clone="createCloneBlock"
            :sort="false"
            @start="$emit('start')"
            @end="$emit('end')"
            class="grid gap-2 2xl:grid-cols-2">
            <template #item="{ element: block, index }">
                <SidebarBlock :block="block" @addBlock="$emit('addBlock', $event)" />
            </template>
        </Draggable>
    </Disclosure>
</template>
